import { Typography } from "@mui/material";
import { DotLegalCheckbox } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import { EntityTemplateField, TemplateEntityType } from "../EntityTemplate.types.ts";
import SystemTemplateField from "../../system/addSystemPane/SystemTemplateField.tsx";
import ContractTemplateField from "../../contract/contractTemplateFields/ContractTemplateField.tsx";
import { useFieldDefaultValueEditor } from "./FieldDefaultValueEditor.hooks.ts";
import SelectableLegalEntityMultiSelect from "../../legalEntity/SelectableLegalEntityMultiSelect.tsx";

export interface FieldDefaultValueEditorProps {
    templateEntityType: TemplateEntityType;
    field: EntityTemplateField;
    onChange: (value: unknown) => void;
}

// Takes the place of the field's read-only preview, so the field itself is where its default value is picked
function FieldDefaultValueEditor(props: FieldDefaultValueEditorProps) {
    const { translateString } = useTranslation();
    const {
        editor,
        allGroupEntityAccess,
        systemDraft,
        contractDraft,
        onSystemChange,
        onSystemTagsChange,
        onSystemCreationFieldChange,
        onContractChange,
        onContractTagsChange,
        onContractPartiesChange,
    } = useFieldDefaultValueEditor(props.templateEntityType, props.field, props.onChange);

    return (
        <>
            {editor === "groupCompanies" && (
                <DotLegalCheckbox
                    checked={allGroupEntityAccess}
                    label={translateString("allGroupEntityAccess")}
                    margin={{ marginLeft: -1.5 }}
                    tooltip={translateString("allGroupEntityAccessTooltip")}
                    onChange={props.onChange}
                />
            )}
            {editor === "system" && (
                <SystemTemplateField
                    field={props.field}
                    name=""
                    onNameChange={() => {}}
                    system={systemDraft.system}
                    onChange={onSystemChange}
                    validationErrors={[]}
                    selectedTagIds={systemDraft.tagIds}
                    onTagsChange={onSystemTagsChange}
                    creationFieldSelections={systemDraft.creationFieldSelections}
                    onCreationFieldChange={onSystemCreationFieldChange}
                />
            )}
            {editor === "contract" && (
                <ContractTemplateField
                    field={props.field}
                    contract={contractDraft.contract}
                    onChange={onContractChange}
                    validationErrors={[]}
                    selectedTagIds={contractDraft.tagIds}
                    onTagsChange={onContractTagsChange}
                    counterPartiesSlot={
                        <SelectableLegalEntityMultiSelect
                            selectedIds={contractDraft.counterPartyLegalEntityIds}
                            onChange={onContractPartiesChange}
                            label={translateString("contractParties")}
                        />
                    }
                />
            )}
            <Typography variant="caption" color="text.secondary">
                {translateString("defaultValueHelpText")}
            </Typography>
        </>
    );
}

export default FieldDefaultValueEditor;
